<template>
  <div class="news_box">
    <section class="w3l-blogpost-content py-5">
      <div class="container py-md-5">
        <div class="header-title mb-md-5 mt-4">
          <span class="sub-title">公司新闻</span>
        </div>
        <div class="row">
          <div class="leftImg">
            <el-carousel :interval="3000" arrow="always" class="slider">
              <el-carousel-item
                v-for="(item, index) in bannerList"
                :key="index"
                class="slider_box"
                
              >
              <div style="cursor: pointer;" @click="jump(item.id)">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="item.picUrl"
                  fit="cover"
                ></el-image>
              </div>
                
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="rightTxt">
            <div style="margin: 20px 5px 5px 20px">
              <div class="asdf" v-for="(item, index) in newsList" :key="index">
                <div class="titles" @click="jump(item.id)">
                  <span>{{ item.newsTitle }} </span>
                </div>
                <div class="times">
                  <div>{{ parseTime(item.createTime, "{y}-{m}-{d}") }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-for="(item,index) in newsList" :key="index" @click="jump(item.id)" style="" class="col-lg-3 col-md-6 item">
            <div class="card">
              <div class="card-header p-0 position-relative">
                <span>
                  <img
                    class="card-img-bottom d-block radius-image-full"
                    :src="item.picUrl"
                    alt="Card image cap"
                  />
                </span>
              </div>
              <div class="card-body blog-details">
                <span style="font-size: 1rem;" class="blog-desc"
                  >{{item.newsTitle}}
                </span>
                <div class="align-items-center">
                  <div>{{item.sketch}}</div>
                  <div>{{item.createTime}}</div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { newslist } from "@/api/news/index";
import { bannerList } from "@/api/menu/index.js";
export default {
  data() {
    return {
      bannerList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 6,
        newsType: 1,
        status:0,
        orderByColumn:'sort',
        isAsc:'desc'
      },
      newsList: [],
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      newslist(this.queryParams).then((res) => {
        console.log(res)
        this.newsList = res.rows;

        for (let i = 0; i < this.newsList.length; i++) {
          const data = {
            picUrl: this.newsList[i].picUrl,
            id:this.newsList[i].id
          };
          this.bannerList.push(data);
        }
        if (this.bannerList == undefined ||this.bannerList == null || this.bannerList.length <= 0) {
          bannerList(this.queryParams).then((res) => {
            this.bannerList = res.rows;
          });
        }
      });
    },
    jump(e) {
      this.$router.push({
        path: "/newsInfo?newsid=" + e,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.slider {
  width: 100%;
  max-height: 500px;
}
.leftImg {
  width: 50%;
  float: left;
}
.rightTxt {
  width: 50%;
  float: left;
  .asdf {
    .titles {
      cursor: pointer;
      width: 75%;
      float: left;
      font-size: 17px;
      line-height: 40px;
      // color: #333;
      color: var(--primary-color);
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      letter-spacing: 1px;
    }
    .times {
      width: 20%;
      float: right;
      font-size: 14px;
      line-height: 40px;
    }
  }
}
.row {
  width: 100%;
  // background-color: aqua;
}



</style>
